import React, { useState, useRef } from "react";
import SimpleReactValidator from 'simple-react-validator';
import Bg2 from "../common/Bg2";
import Helmet from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useAuth } from "../../contexts/AuthProvider";
import { supabase } from "../../utils/supabaseClient";
const Register = () => {

    const validator = useRef(
        new SimpleReactValidator({
            messages: {
                required: "پر کردن این فیلد الزامی میباشد",
                min: "کمتر از 5 کاراکتر نباید باشد",
                email: "ایمیل نوشته شده صحیح نمی باشد"
            },
            element: message => <div style={{ color: "red" }}>{message}</div>
        })
    );






    const { signUp, user } = useAuth();


    // const [confirmpassword, setconfirmpassword] = useState("");

    const [email, setemail] = useState("");
    const [name, setname] = useState("");
    const [password, setpassword] = useState("");
    const [forceUpdate] = useState();

    const [policy, setPolicy] = useState("");
    //const [errorMessage, seterrorMessage] = useState(null);

    const getProfiles = async () => {

        const { data, error } = await supabase
            .from("profiles")
            .insert([
                {
                    username: name,


                }])

    }

    const SignUpUser = (e, email, password, name) => {
        e.preventDefault();
        if (validator.current.allValid()) {

            signUp({ email, password, name });
            toast.success("لینک تاییدیه به ایمیل شما ارسال شد", {
                position: toast.POSITION.TOP_CENTER
            });

            getProfiles();
        } else {
            toast.error("لطفا اطلاعاتتان را کامل کنید", {
                position: toast.POSITION.TOP_CENTER
            });
            validator.current.showMessages();
            // validator.current.showMessageFor("name")
            forceUpdate(1);
        }
    };


    return (
        <div className="landing-layer" style={{ background: "none" }}>
            <Helmet>
                <title>
                    ماه کورس | عضویت در سایت
                </title>
            </Helmet>
            <ToastContainer rtl={true} theme="dark" />
            <Bg2 />
            <main className="client-page">
                <div className="container-content">
                    <header>
                        <h2 style={{ textShadow: "none", color: "black" }}> عضویت در سایت </h2>
                    </header>

                    <div className="form-layer">
                        <form onSubmit={(e) => SignUpUser(e, email, password, name

                        )} >
                            <div className="input-group">
                                <span className="input-group-addon" id="username">
                                    <i className="zmdi zmdi-account"></i>
                                </span>
                                <input
                                    value={name}
                                    onChange={e => {
                                        setname(e.target.value);
                                        validator.current.showMessageFor("setname")

                                    }

                                    }
                                    type="text"
                                    className="form-control"
                                    placeholder="نام و نام خانوادگی"
                                    aria-describedby="username"
                                    name="name"

                                />

                            </div>
                            {validator.current.message("name", name, "required|min:5 ")}
                            <div className="input-group">
                                <span
                                    className="input-group-addon"
                                    id="email-address"
                                >
                                    <i className="zmdi zmdi-email"></i>
                                </span>
                                <input
                                    name="email"
                                    value={email}
                                    onChange={e => {
                                        setemail(e.target.value);
                                        validator.current.showMessageFor("email")

                                    }}

                                    type="text"
                                    className="form-control"
                                    placeholder="ایمیل"
                                    aria-describedby="email-address"
                                />
                            </div>
                            {validator.current.message("email", email, "required|email")}
                            <div className="input-group">
                                <span className="input-group-addon" id="password">
                                    <i className="zmdi zmdi-lock"></i>
                                </span>
                                <input
                                    name="password"
                                    value={password}
                                    onChange={e => {
                                        setpassword(e.target.value);
                                        validator.current.showMessageFor("password")

                                    }}

                                    type="password"
                                    className="form-control"
                                    placeholder="رمز عبور "
                                    aria-describedby="password"
                                />
                            </div>
                            {validator.current.message("password", password, "required|min:5")}

                            <div className="accept-rules">
                                <label>
                                    <input type="checkbox" name="policy" value={policy} onChange={e => {
                                        setPolicy(e.currentTarget.checked);
                                        validator.current.showMessageFor("policy")

                                    }} /> قوانین و
                                    مقررات سایت را میپذیرم{" "}
                                </label>
                                {validator.current.message("policy", policy, "required")}
                            </div>

                            <div className="link">
                                <a href="">
                                    {" "}
                                    <i className="zmdi zmdi-assignment"></i> قوانین
                                    و مقررات سایت !
                                </a>
                                <a href="">
                                    {" "}
                                    <i className="zmdi zmdi-account"></i> ورود به
                                    سایت{" "}
                                </a>
                            </div>

                            <button

                                className="btn btn-success">
                                {" "}
                                عضویت در سایت{" "}
                            </button>
                        </form>
                    </div>
                </div>
            </main>


        </div>
    );
};

export default Register;
